import axios from "axios";
import { useEffect, useState } from "react";
import "../css/mobilesignup.css"

export default function FindId1({ onNext }) {
    // OTP 상태
    const [otpSending, setOtpSending] = useState(false);
    const [otpVerifying, setOtpVerifying] = useState(false);
    const [otpCode, setOtpCode] = useState("");
    const [otpVerified, setOtpVerified] = useState(false);
    const [cooldown, setCooldown] = useState(0);

    const fmt = (s) => {
        const m = Math.floor(Math.max(0, s) / 60);
        const sec = Math.max(0, s) % 60;
        return `${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
    };

    // ✅ 전화번호는 '문자열' 하나로 관리
    const [phoneNumber, setPhoneNumber] = useState("");

    // 숫자만 추출해서 10~11자리 검증
    const digits = (phoneNumber || "").replace(/\D/g, "");
    const isValidPhone = /^\d{10,11}$/.test(digits);

    const handlerInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "phoneNumber") {
            setPhoneNumber(value);     // ✅ 상태 갱신
            setOtpVerified(false);     // 번호가 바뀌면 인증 초기화
        }
    };

    const toE164KR = (raw) => {
        const only = (raw || "").replace(/\D/g, "");
        if (only.startsWith("0")) return "+82" + only.substring(1);
        return only.startsWith("+") ? only : "+" + only;
    };

    const handleSendOtp = () => {
        if (!isValidPhone) {
            alert("전화번호를 숫자만 10~11자리로 입력해주세요.");
            return;
        }
        if (cooldown > 0 || otpSending) return;

        setOtpSending(true);
        const phone = toE164KR(phoneNumber); // ✅ 문자열 그대로 변환
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/auth/otp/request`, { phone })
            .then(() => {
                alert("인증번호를 발송했어요.");
                setCooldown(180);
            })
            .catch((err) => {
                console.error(err);
                alert("인증번호 발송 중 오류가 발생했습니다.");
            })
            .finally(() => setOtpSending(false));
    };

    const handleVerifyOtp = () => {
        if (!isValidPhone) {
            alert("전화번호를 숫자만 10~11자리로 입력해주세요.");
            return;
        }
        if (!otpCode.trim()) {
            alert("인증번호를 입력해주세요.");
            return;
        }
        setOtpVerifying(true);
        const phone = toE164KR(phoneNumber); // ✅ 문자열 그대로 변환
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/auth/otp/verify`, { phone, code: otpCode.trim() })
            .then(({ data }) => {
                if (data && data.ok === true) {
                    setOtpVerified(true);
                    alert("전화번호 인증이 완료되었습니다.");
                } else {
                    setOtpVerified(false);
                    alert("인증에 실패했습니다. 인증번호를 다시 확인해주세요.");
                }
            })
            .catch((err) => {
                console.error(err);
                setOtpVerified(false);
                alert("인증 확인 중 오류가 발생했습니다.");
            })
            .finally(() => setOtpVerifying(false));
    };

    // ✅ 쿨다운 타이머 (하나만 유지)
    useEffect(() => {
        if (cooldown <= 0) return;
        const t = setInterval(() => {
            setCooldown((c) => Math.max(0, c - 1));
        }, 1000);
        return () => clearInterval(t);
    }, [cooldown]);

    const handleFindId = async () => {
        if (!otpVerified) {
            alert("전화번호 인증을 먼저 완료해주세요.");
            return;
        }
        try {
            const e164 = toE164KR(phoneNumber);
            const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/findid`, {
                phoneNumber: e164,
            });

            // 백엔드 응답 키에 맞춰 사용 (예: idMasked 또는 id)
            const idMasked = data?.idMasked ?? data?.id ?? null;

            // 🔹 부모로 결과 전달 → 부모가 step 전환
            onNext({ idMasked, phoneNumber: e164 });
        } catch (e) {
            console.error(e);
            alert("아이디 찾기 중 오류가 발생했습니다.");
        }
    };

    return (
        <>
            <div className="FindId_Header">
                <p>아이디 찾기</p>
            </div>
            <div className="FindId_Mid">
                <p>본인인증</p>
                <p>등록한 전화번호를 입력해주세요</p>
            </div>

            <div className="FindId_Phone">
                <div>
                    <div>
                        <input
                            type="text"
                            name="phoneNumber"
                            value={phoneNumber}                 // ✅ 문자열 바인딩
                            onChange={handlerInputChange}
                            placeholder="숫자만 입력해주세요"
                            inputMode="numeric"                 // (권장) 모바일 키패드
                        />
                        <button
                            type="button"
                            onClick={handleSendOtp}
                            disabled={!isValidPhone || otpSending || cooldown > 0}
                            className={`btn-otp ${isValidPhone && !otpSending && cooldown === 0 ? "is-active" : ""}`}
                            aria-disabled={!isValidPhone || otpSending || cooldown > 0}
                        >
                            {cooldown > 0 ? `재전송(${fmt(cooldown)})` : "코드발송"}
                        </button>
                    </div>
                    <div>
                        <input
                            type="text"
                            value={otpCode}
                            onChange={(e) => setOtpCode(e.target.value)}
                            placeholder="인증번호를 입력해주세요"
                            inputMode="numeric"
                        />
                        <button
                            type="button"
                            onClick={handleVerifyOtp}
                            disabled={otpVerifying || !otpCode.trim()}
                            className={`btn-verify ${otpCode.trim() ? "is-active" : ""}`}
                            aria-disabled={otpVerifying || !otpCode.trim()}
                        >
                            인증확인
                        </button>
                    </div>
                    {otpVerified ? (
                        <small style={{ color: "green" }}>✅ 전화번호 인증 완료</small>
                    ) : (
                        <small style={{ color: "#666" }}>인증 완료 후 아이디 찾기가 가능합니다.</small>
                    )}
                </div>
            </div>
            <div className="FindId_button">
                <button onClick={handleFindId} disabled={!otpVerified}>아이디 찾기</button>
            </div>
        </>
    );
}
